import { createSlice } from '@reduxjs/toolkit';

export const ApplicationSlice = createSlice({
    name: 'application',
    initialState: {
        applicationsList: []
    },
    reducers: {
        setApplicationsListRedux: ( state, { payload } ) => {
            state.applicationsList  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setApplicationsListRedux } = ApplicationSlice.actions;